import React, { useEffect, useState, useContext } from "react";
import {
  ButtonNew,
  ButtonSeach,
  Buttons,
  Card,
  Contanier,
  Forms,
  Gruop,
  Header,
  Image,
  Title,
  paragrafo,
} from "./style";
import Icone from "../../../utils/Icone";
import Url_Image from "../../../assets/URL'S/Url_Image";

export default function ViewPicture({ viewPicture, setViewPicture, img, setImgAluno }) {
  if (!viewPicture) return null;

  return (
    <Contanier>
      <Card>
        <Header>
          <Buttons
            onClick={() => {
              setViewPicture(false);
              setImgAluno("");
            }}
          >
            <Icone name={"X"} color={" #3a3f86"} size={50} />
          </Buttons>
        </Header>
        <Image src={img} alt="logo" />
      </Card>
    </Contanier>
  );
}
